import styled from "styled-components";

export const WorkOrderWrapper = styled.div`
div#react-select-2-placeholder {
    position: relative;
    top: 0px !important;
}

.box-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 10px;
    margin-bottom: 16px;
}

.sku-box {
    padding: 8px 14px;
    min-width: 120px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: all 0.15s ease;
    &.active-box {
      box-shadow: 0 0 0 2px currentColor;
    }
    h4 {
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 0;
      line-height: 1.2;
      color: inherit;
    }
    p {
      color: #6B7280;
      font-size: 10px;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      margin-bottom: 2px;
    }
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }
    &.box-purple {
      background: rgba(104, 72, 186, 0.06);
      border: 1px solid rgba(104, 72, 186, 0.2);
      color: #6848BA;
    }
    &.box-gray {
      background: rgba(126, 138, 144, 0.06);
      border: 1px solid rgba(126, 138, 144, 0.2);
      color: #7E8A90;
    }
    &.box-blue {
      background: rgba(21, 101, 216, 0.06);
      border: 1px solid rgba(21, 101, 216, 0.2);
      color: #1565D8;
    }
    &.box-orange {
      background: rgba(255, 153, 0, 0.06);
      border: 1px solid rgba(255, 153, 0, 0.2);
      color: #FF9900;
    }
    &.box-green {
      background: rgba(0, 156, 52, 0.06);
      border: 1px solid rgba(0, 156, 52, 0.2);
      color: #009C34;
    }
}

.wo-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    gap: 16px;

    .toolbar-left {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
    }

    .toolbar-title {
      font-size: 18px;
      font-weight: 700;
      color: #1B2559;
      margin: 0;
    }

    .toolbar-count {
      background: rgba(21, 101, 216, 0.08);
      color: #1565D8;
      font-size: 12px;
      font-weight: 600;
      padding: 2px 10px;
      border-radius: 12px;
      line-height: 1.4;
    }

    .toolbar-right {
      display: flex;
      align-items: center;
      gap: 10px;
      .toolbar-search {
        margin-bottom: 0;
        input.form-control {
          height: 32px;
          padding-top: 4px;
          padding-bottom: 4px;
        }
        .form-group {
          margin-bottom: 0;
        }
      }
      .select2-container {
        margin-bottom: 0 !important;
      }
    }
}

.wo-status-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    &.badge-draft { background: rgba(126, 138, 144, 0.1); color: #7E8A90; }
    &.badge-confirmed { background: rgba(21, 101, 216, 0.08); color: #1565D8; }
    &.badge-in-progress { background: rgba(255, 153, 0, 0.1); color: #FF9900; }
    &.badge-done { background: rgba(0, 156, 52, 0.08); color: #009C34; }
}

.date-item-wrapper {
    display: flex;
    flex-direction: column;
    grid-row-gap: 3px;
    span {
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    text-align: left;
    color: #535E63;
    &:not(:first-child){
      font-size: 10px;
      color: #989898;
      font-weight: 400;
    }
}
}
.two-line-ellipsis{
  height: auto !important;
}
svg.delete-icon {
    color: #D95040;
    font-size: 22px;
    cursor: pointer;
}
.action-icons{
    width: 22px;
 }
`;
